/**
 * kult-seminar-agenda.js — „Die Reise der Bohne“ (Agenda der Kaffeeseminar-Seite).
 * Desktop (hover-fähig, ≥960): Überfahren eines Punkts zeigt ihn auf der Bühne rechts, Klick hält ihn
 * fest; Standard ist Punkt 1. Mobil/Touch: Tipp klappt den Punkt in place auf (nur einer offen).
 * Tastatur: Enter/Space toggelt, Pfeil ↑/↓ wechselt den Punkt.
 * Röstgrad-Level: Titel aus <script data-agenda-levels> (Index = aktiver Punkt, 0 = Start), Bohnenfarbe
 * (--roast), Meter, Schiene (--agenda-progress). Die Bühne klont den Panel-Inhalt des aktiven Punkts
 * und übernimmt die Level-Leiste (auf Desktop wird sie in die Bühne verschoben).
 */
(function () {
  'use strict';
  if (customElements.get('kult-seminar-agenda')) return;

  var hoverMq = window.matchMedia('(hover: hover) and (pointer: fine)');
  var deskMq = window.matchMedia('(min-width: 960px)');
  var motionMq = window.matchMedia('(prefers-reduced-motion: no-preference)');

  class KultSeminarAgenda extends HTMLElement {
    connectedCallback() {
      var self = this;
      try { this.levels = JSON.parse((this.querySelector('[data-agenda-levels]') || {}).textContent || '[]').map(function (l) { return String(l).trim(); }); } catch (e) { this.levels = []; }
      this.items = Array.prototype.slice.call(this.querySelectorAll('[data-agenda-item]'));
      this.max = this.items.length;
      this.hint = this.dataset.levelHint || 'Schritt {n} von {max}';
      this.level = this.querySelector('[data-agenda-level]');
      this.stageInner = this.querySelector('[data-agenda-stage-inner]');
      this.stageMode = deskMq.matches;
      this.pinned = this.stageMode ? 1 : 0;
      this.active = this.pinned;

      this.addEventListener('click', this._onClick.bind(this));
      this.addEventListener('keydown', this._onKeydown.bind(this));
      if (hoverMq.matches) {
        this.addEventListener('pointerover', this._onOver.bind(this));
        var list = this.querySelector('[data-agenda-list]');
        if (list) list.addEventListener('pointerleave', this._onLeave.bind(this));
      }
      var onMode = function () {
        var desk = deskMq.matches;
        if (desk === self.stageMode) return;
        self.stageMode = desk;
        self.pinned = desk ? Math.max(1, self.pinned) : 0;
        self.active = self.pinned;
        self.render(true);
      };
      if (deskMq.addEventListener) deskMq.addEventListener('change', onMode); else deskMq.addListener(onMode);

      this.render(true);
      this.classList.add('is-ready');
    }

    indexOf(item) { return parseInt(item.dataset.agendaIndex, 10) || 0; }

    open(index) { this.active = index; this.render(); }

    render(immediate) {
      var self = this, active = this.active, mobileOpen = this.stageMode ? 0 : active;
      this.items.forEach(function (item) {
        var i = self.indexOf(item), btn = item.querySelector('[data-agenda-toggle]'), panel = item.querySelector('.kult-sem-agenda__panel');
        btn.setAttribute('aria-expanded', i === mobileOpen ? 'true' : 'false');
        if (panel) panel.hidden = i !== mobileOpen;
        item.classList.toggle('kult-sem-agenda__stop--active', i === active);
        item.classList.toggle('kult-sem-agenda__stop--done', i < active);
      });

      var list = this.querySelector('[data-agenda-list]');
      var pct = active <= 1 || this.max <= 1 ? 0 : ((active - 1) / (this.max - 1)) * 100;
      if (list) list.style.setProperty('--agenda-progress', pct + '%');

      var title = this.levels[active] || this.levels[this.levels.length - 1] || '';
      var roast = this.max ? Math.round((active / this.max) * 100) : 0;
      var titleEl = this.querySelector('[data-agenda-level-title]');
      if (titleEl) titleEl.textContent = title;
      var bean = this.querySelector('[data-agenda-bean]');
      if (bean) bean.style.setProperty('--roast', roast + '%');
      var fill = this.querySelector('[data-agenda-fill]');
      if (fill) fill.style.width = roast + '%';
      var meter = this.querySelector('[data-agenda-meter]');
      if (meter) { meter.setAttribute('aria-valuenow', String(active)); meter.setAttribute('aria-valuetext', title); }
      var step = this.querySelector('[data-agenda-level-step]');
      if (step) step.textContent = this.hint.replace('{n}', String(active)).replace('{max}', String(this.max));

      if (this.stageMode) this.renderStage(immediate);
      else this.restoreLevel();
    }

    /* Bühne (Desktop): Panel-Inhalt klonen, Level-Leiste anhängen */
    renderStage(immediate) {
      var self = this, stage = this.stageInner;
      if (!stage) return;
      var item = this.items[Math.max(0, this.active - 1)];
      var content = item && item.querySelector('[data-agenda-content]');
      if (!content) return;
      var swap = function () {
        var clone = content.cloneNode(true);
        clone.removeAttribute('data-agenda-content');
        clone.classList.add('kult-sem-agenda__stage-content');
        clone.querySelectorAll('img[loading="lazy"]').forEach(function (img) { img.loading = 'eager'; });
        stage.innerHTML = '';
        stage.appendChild(clone);
        if (self.level) stage.appendChild(self.level);
        stage.classList.remove('is-switching');
      };
      if (immediate || !motionMq.matches || !stage.firstChild) { swap(); return; }
      stage.classList.add('is-switching');
      clearTimeout(this._swapTimer);
      this._swapTimer = setTimeout(swap, 180);
    }

    restoreLevel() {
      if (this.level && this.level.parentNode !== this) this.insertBefore(this.level, this.querySelector('[data-agenda-list]'));
    }

    _onClick(e) {
      var btn = e.target.closest('[data-agenda-toggle]');
      if (!btn) return;
      var i = this.indexOf(btn.closest('[data-agenda-item]'));
      if (this.stageMode) { this.pinned = i; this.open(i); return; }
      if (this.pinned === i) { this.pinned = 0; this.open(0); return; }
      this.pinned = i; this.open(i);
    }

    _onKeydown(e) {
      var btn = e.target.closest('[data-agenda-toggle]');
      if (!btn || (e.key !== 'ArrowDown' && e.key !== 'ArrowUp')) return;
      e.preventDefault();
      var i = this.indexOf(btn.closest('[data-agenda-item]'));
      var next = e.key === 'ArrowDown' ? Math.min(this.max, i + 1) : Math.max(1, i - 1);
      var target = this.items[next - 1] && this.items[next - 1].querySelector('[data-agenda-toggle]');
      if (target) { target.focus(); this.pinned = next; this.open(next); }
    }

    _onOver(e) {
      if (!this.stageMode) return;
      var item = e.target.closest && e.target.closest('[data-agenda-item]');
      if (!item || !this.contains(item)) return;
      var i = this.indexOf(item);
      if (i !== this.active) this.open(i);
    }

    _onLeave() {
      if (this.stageMode && this.active !== this.pinned) this.open(this.pinned);
    }
  }

  customElements.define('kult-seminar-agenda', KultSeminarAgenda);
})();
